import { ComponentType, SVGProps } from "react";
import { SVG_PATHS } from "../../constants/svgPaths"; 

type SVGIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const UserSvgIcon: SVGIconComponent = (props) => {
    const {
      className = "",
      fill = "currentColor",
      viewBox = "0 0 24 24",
      ...rest
    } = props;
  
    return (
      <svg className={className} viewBox={viewBox} fill={fill} {...rest}>
        <path d={SVG_PATHS.USER} />
      </svg>
    );
};

const PlusSvgIcon: SVGIconComponent = (props) => {
    const {
      className = "",
      fill = "currentColor",
      viewBox = "0 0 24 24",
      color,
      ...rest
    } = props;
  
    return (
      <svg className={className} viewBox={viewBox} fill={fill} color={color} {...rest}>
        <path d={SVG_PATHS.PLUS} />
      </svg>
    );
};


const EyeSvgIcon: SVGIconComponent = (props) => {
    const {
      className = "",
      fill = "currentColor",
      viewBox = "0 0 24 24",
      color,
      ...rest
    } = props;
  
    return (
        <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.INTERNALEYE} />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.EXTERNALEYE} />
      </svg>
    );
};

const EyeOffSvgIcon: SVGIconComponent = (props) => {
    const {
      className = "",
      fill = "currentColor",
      viewBox = "0 0 24 24",
      color,
      ...rest
    } = props;
  
    return (
        <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.EYEOFF} />
      </svg>
    );
};

const SuccessfulSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path fillRule="evenodd" d={SVG_PATHS.SUCCESSFUL} clipRule="evenodd" />
    </svg>
  );
};

const ErrorSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path fillRule="evenodd" d={SVG_PATHS.ERROR} clipRule="evenodd" />
    </svg>
  );
};

const WarningSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path fillRule="evenodd" d={SVG_PATHS.WARNING} clipRule="evenodd" />
    </svg>
  );
};

const InfoSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path fillRule="evenodd" d={SVG_PATHS.INFO} clipRule="evenodd" />
    </svg>
  );
};

const FacebookSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path d={SVG_PATHS.FACEBOOK} />
    </svg>
  );
};

const InstagramSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path d={SVG_PATHS.INSTAGRAM} />
    </svg>
  );
};

const LinkedinSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    ...rest
  } = props;

  return (
      <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
        <path d={SVG_PATHS.LINKEDIN} />
    </svg>
  );
};

const ProfileSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    stroke = "currentColor",
    ...rest
  } = props;

  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.PROFILE} />
    </svg>
  );
};

const ToggleSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    stroke = "currentColor",
    ...rest
  } = props;

  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.TOGGLE} />
    </svg>
  );
};


const CloseSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    stroke = "currentColor",
    ...rest
  } = props;

  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.CLOSE} />
    </svg>
  );
};

const SearchSvgIcon: SVGIconComponent = (props) => {
  const {
    className = "",
    fill = "currentColor",
    viewBox = "0 0 24 24",
    color,
    stroke = "currentColor",
    ...rest
  } = props;

  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.SEARCH} />
    </svg>
  );
};

const WhatsappSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "currentColor", viewBox = "0 0 24 24", ...rest } = props;
  return (
    <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
      <path d={SVG_PATHS.WHATSAPP} />
    </svg>
  );
};

const PhoneSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "currentColor", viewBox = "0 0 24 24", ...rest } = props;
  return (
    <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
      <path d={SVG_PATHS.PHONE} />
    </svg>
  );
};

const MailSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "currentColor", viewBox = "0 0 24 24", ...rest } = props;
  return (
    <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
      <path d={SVG_PATHS.MAIL} />
    </svg>
  );
};

const MapPinSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "currentColor", viewBox = "0 0 24 24", ...rest } = props;
  return (
    <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
      <path d={SVG_PATHS.MAP_PIN} />
    </svg>
  );
};

const ArrowRightSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.ARROW_RIGHT} />
    </svg>
  );
};

const ArrowUpRightSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.ARROW_UP_RIGHT} />
    </svg>
  );
};

const CheckSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
  return (
    <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d={SVG_PATHS.CHECK} />
    </svg>
  );
};

const SparkSvgIcon: SVGIconComponent = (props) => {
  const { className = "", fill = "currentColor", viewBox = "0 0 24 24", ...rest } = props;
  return (
    <svg className={className} fill={fill} viewBox={viewBox} {...rest}>
      <path d={SVG_PATHS.SPARK} />
    </svg>
  );
};

const iconSvgMap: Record<string, SVGIconComponent> = {
    user: UserSvgIcon,
    plus: PlusSvgIcon,
    eyeoff: EyeOffSvgIcon,
    eye: EyeSvgIcon,
    successful: SuccessfulSvgIcon,
    error: ErrorSvgIcon,
    warning: WarningSvgIcon,
    info: InfoSvgIcon,
    facebook: FacebookSvgIcon,
    instagram: InstagramSvgIcon,
    linkedin: LinkedinSvgIcon,
    profile: ProfileSvgIcon,
    toggle: ToggleSvgIcon,
    close: CloseSvgIcon,
    search: SearchSvgIcon,
    whatsapp: WhatsappSvgIcon,
    phone: PhoneSvgIcon,
    mail: MailSvgIcon,
    map: MapPinSvgIcon,
    arrowRight: ArrowRightSvgIcon,
    arrowUpRight: ArrowUpRightSvgIcon,
    check: CheckSvgIcon,
    spark: SparkSvgIcon,
    minus: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d={SVG_PATHS.MINUS} />
        </svg>
      );
    },
    heart: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.HEART} />
        </svg>
      );
    },
    share: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.SHARE} />
        </svg>
      );
    },
    cart: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.CART} />
        </svg>
      );
    },
    chevronRight: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={SVG_PATHS.CHEVRON_RIGHT} />
        </svg>
      );
    },
    lock: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.LOCK} />
        </svg>
      );
    },
    shield: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.SHIELD} />
        </svg>
      );
    },
    at: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.AT} />
        </svg>
      );
    },
    building: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.BUILDING} />
        </svg>
      );
    },
    upload: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.UPLOAD} />
        </svg>
      );
    },
    file: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.FILE} />
        </svg>
      );
    },
    fileText: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.FILE_TEXT} />
        </svg>
      );
    },
    logout: (props) => {
      const { className = "", fill = "none", viewBox = "0 0 24 24", stroke = "currentColor", ...rest } = props;
      return (
        <svg className={className} fill={fill} stroke={stroke} viewBox={viewBox} {...rest}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={SVG_PATHS.LOGOUT} />
        </svg>
      );
    },
}

export default iconSvgMap;